const ConditionalWrapper = ({
    condition,
    wrapper,
    children
}: {
    condition?: boolean;
    wrapper: (children: JSX.Element) => JSX.Element ;
    children: JSX.Element
} ) => condition ? wrapper(children) : children

export default ConditionalWrapper